export default ({ globals }) => {
	globals.class.set({
		'product-card__discount': 'success--text font-weight-bold font-1',
	})
}
